export const environment = {
  production: true,
  APIEndpoint: 'http://vmi313621.contaboserver.net/Software_backend/',
};
